// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbContainer":"Breadcrumb_breadcrumbContainer___iJal"};